import { createReducer } from "reduxsauce";
import Types from "./types";

export const INITIAL_STATE = {
    walkInVisitData: null,
    orderIdInput: "",
    confirmationMessage: null,
    loading: false,
    error: false
};

export const submitWalkInYardVisitInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        loading: true,
        error: false,
        confirmationMessage: null
    };
};

export const submitWalkInYardVisitSuccess = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        walkInVisitData: data,
        loading: false,
        error: false
    };
};

export const submitWalkInYardVisitFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        loading: false,
        error
    };
};

export const confirmEmailInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        loading: true,
        error: false
    };
};

export const confirmEmailSuccess = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        walkInVisitData: data,
        loading: false,
        error: false
    };
};

export const confirmEmailFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        loading: false,
        error
    };
};

export const updateOrderIdInput = (state = INITIAL_STATE, { orderId }) => {
    return {
        ...state,
        orderIdInput: orderId
    };
};

export const setYardConfirmationMessage = (state = INITIAL_STATE, { message }) => {
    return {
        ...state,
        confirmationMessage: message || null
    };
};

export const HANDLERS = {
    [Types.SUBMIT_WALK_IN_YARD_VISIT_INIT]: submitWalkInYardVisitInit,
    [Types.SUBMIT_WALK_IN_YARD_VISIT_SUCCESS]: submitWalkInYardVisitSuccess,
    [Types.SUBMIT_WALK_IN_YARD_VISIT_FAILURE]: submitWalkInYardVisitFailure,

    [Types.CONFIRM_EMAIL_INIT]: confirmEmailInit,
    [Types.CONFIRM_EMAIL_SUCCESS]: confirmEmailSuccess,
    [Types.CONFIRM_EMAIL_FAILURE]: confirmEmailFailure,

    [Types.UPDATE_ORDER_ID_INPUT]: updateOrderIdInput,
    [Types.SET_YARD_CONFIRMATION_MESSAGE]: setYardConfirmationMessage
};

export default createReducer(INITIAL_STATE, HANDLERS);
